enum ScormEnum {
	ISPRING = 'ispring',
	GENIALLY = 'genially',
	ARTICULATE = 'articulate_storyline',
}

export default ScormEnum;

export const SCORM_TYPES = {
	[ScormEnum.ISPRING]: 'Ispring',
	[ScormEnum.GENIALLY]: 'Genially',
	[ScormEnum.ARTICULATE]: 'Articulate Storyline',
};
